export const getYear = state => state.reportVehicleKilometersTotal.getIn(['list', 'year'])
export const getData = state => state.reportVehicleKilometersTotal.getIn(['list', 'data'])
export const getFetching = state => state.reportVehicleKilometersTotal.getIn(['list', 'fetching'])
export const getError = state => state.reportVehicleKilometersTotal.getIn(['list', 'error'])

export const getDetailsData = state => state.reportVehicleKilometersTotal.getIn(['details', 'data'])
export const getDetailsFetching = state => state.reportVehicleKilometersTotal.getIn(['details', 'fetching'])
export const getDetailsError = state => state.reportVehicleKilometersTotal.getIn(['details', 'error'])
